export const GRETA_AI_CHAT_HISTORY_PAGE_SIZE = 50

export const GRETA_AI_CHAT_HISTORY_PARAMS = {
  page_size: GRETA_AI_CHAT_HISTORY_PAGE_SIZE,
  view: 'chat',
}
